<template>
  <van-dialog
    v-model="show"
    title="请选择问题类型并留言反馈"
    show-cancel-button
    confirm-button-color="#6c7ef3"
    :beforeClose="beforeClose"
  >
    <van-tabs type="card" @click="tabsClick" v-model="tabType">
      <van-tab
        v-for="feedbackType in feedbackTypeList"
        :title="feedbackType.value"
        :name="feedbackType.value"
        :key="feedbackType.id"
      ></van-tab>
    </van-tabs>
    <van-field
      v-model="content"
      clearable
      type="textarea"
      :placeholder="placeholder"
      :border="input_border"
      class="singleInput"
    />
  </van-dialog>
</template>
<script>
import { Field, Toast, Icon, Dialog, Tab, Tabs } from "vant";
import api from "@/api/list";
export default {
  name: "leave-message",
  props: {
    showDialog: null,
    emolumentDetail: Object
  },
  components: {
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
    [Dialog.Component.name]: Dialog.Component
  },
  data() {
    return {
      show: this.showDialog,
      input_border: false,
      content: "", //留言内容
      tabType: "", //留言类型,
      type: "",
      feedbackTypeList: [],
      placeholder: "请选择问题类型并留言反馈"
    };
  },
  watch: {
    showDialog: function(val) {
      this.show = val;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      api.getDataDictList({ group: "contentFeedbackType" }).then(res => {
        if (res.data.status == "200") {
          this.feedbackTypeList = res.data.data;
          this.feedbackTypeList.splice(
            this.feedbackTypeList.findIndex(
              item => item.code === "bjnews_feedback"
            ),
            1
          );
          if (res.data.data.length > 0) {
            this.placeholder = ` 请填写${res.data.data[0].value}问题反馈...`;
            this.type = res.data.data[0].id;
          }
        }
      });
    },
    tabsClick(name) {
      for (let temp of this.feedbackTypeList) {
        if (temp.value == name) {
          this.type = temp.id;
          break;
        }
      }
      this.placeholder = `请选择${name}并留言反馈`;
    },
    beforeClose(action, done) {
      if (action == "confirm") {
        if (this.content == "") {
          this.$toast("留言不能为空");
          done(false);
        } else {
          let parm = {
            type: this.type,
            content: this.content,
            username: this.emolumentDetail.username,
            employeeName: this.emolumentDetail.name,
            mobile: this.emolumentDetail.mobile,
            companyName: this.emolumentDetail.ecompanyName
          };
          api.contentFeedbackPostAction(parm, { method: "post" }).then(res => {
            if (res.data.status == "200") {
              Toast({
                type: "success",
                forbidClick: true, // 禁用背景点击
                message: "反馈成功"
              });
            } else {
              Toast({
                type: "error",
                forbidClick: true, // 禁用背景点击
                message: res.data.message
              });
              done(false);
            }
          });
          done();
          this.content = "";
          this.$emit("closeDialog");
        }
      } else {
        done();
        this.$emit("closeDialog");
      }
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .van-tab {
  font-size: 12px;
}
.singleInput {
  width: 91%;
  margin: 20px auto 10px;
  border: 1px solid #ddd;
  border-radius: 2px;
}
</style>
